import { render, staticRenderFns } from "./changeImg.vue?vue&type=template&id=aeb2ce72&"
import script from "./changeImg.vue?vue&type=script&lang=js&"
export * from "./changeImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports